// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"574775d6","253":"d76803f2","305":"da4161a7","311":"7bcc6c9c","379":"c1b27f9a","482":"58aac0db","545":"556a9865","921":"5abfda5a","975":"263ce509","997":"535b7b8e"}[chunkId] + ".chunk.js";
};